import grey from 'material-ui/colors/grey';
const styles = theme => ({
    root: {
        width: '100%',
        marginTop: 0,
        overflowX: 'auto',
    },
    rootGrid: {
        flexGrow: 1,
    },
    table: {
        minWidth: 700,
        overflowX: 'auto',
    },
    tableCellCenter: {
        textAlign: 'center',
        padding: '0',
        width: '10%'
    },
    headerLabels: {
        marginLeft: '20px',
        fontWeight: '700',
        fontSize: '0.9rem',
    },
    groupRows: {
        background: grey[300],
        fontWeight: '700',
        fontSize: '0.9rem',
    },
    permissionsRows: {
        paddingLeft: '50px',
    },
    buttons: {
        padding: '15px 0 7px 15px'
    },
    disabledCheckboxes: {
        color: 'rgba(0, 88, 61, 0.61)'
    },
    [theme.breakpoints.up('sm')]: {
        root: {
            width: '90%',
        },
    },
    [theme.breakpoints.up('md')]: {
        root: {
            width: '95%',
        },
    },
    [theme.breakpoints.up('lg')]: {
        root: {
            width: '100%',
        },
    },
});

export default styles;


// WEBPACK FOOTER //
// ./src/containers/roles/style/styles.js